<template>
    <div class="bg-base-200 h-screen-header rounded-xl">
        <div class="flex flex-col h-full">
            <!-- 设备选择区域 -->
            <div class="bg-base-100 rounded-xl m-4 p-6">
                <h1 class="text-2xl font-bold mb-6 flex items-center">
                    <svg t="1734160766139" class="fill-current icon h-6 w-6 mr-2" viewBox="0 0 1024 1024"
                        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1470" width="200" height="200">
                        <path
                            d="M753.564731 337.471035c-45.8697 0-160.259984 113.849978-243.789399 194.548928C383.134027 654.383848 263.508509 773.284865 167.764911 773.284865l-58.892295 0c-24.068162 0-43.581588-19.526729-43.581588-43.581588s19.513426-43.581588 43.581588-43.581588l58.892295 0c60.504002 0 183.002964-121.68134 281.432741-216.784348 119.79641-115.744117 223.254713-219.029482 304.368102-219.029482l56.209186 0-59.641355-57.828057c-17.033955-16.993023-17.060561-42.902112-0.057305-59.927881 17.002232-17.030885 44.596707-17.064654 61.631686-0.065492l134.207631 133.874033c8.192589 8.172123 12.794397 19.238157 12.794397 30.803563 0 11.564383-4.601808 22.604834-12.794397 30.776957L811.706943 461.72599c-8.505721 8.486278-19.646456 12.522198-30.78719 12.522198-11.166317 0-22.333658-4.676509-30.844495-13.199627-17.003256-17.025769-16.975627-45.432749 0.057305-62.425771l59.641355-61.151755L753.564731 337.471035zM811.706943 561.66105c-17.034978-16.999163-44.629453-16.972557-61.631686 0.058328-17.003256 17.024745-16.975627 46.257533 0.057305 63.250556l59.641355 61.150732-56.209186 0c-35.793204 0-95.590102-52.946886-154.87637-108.373243-17.576307-16.435321-45.161572-16.3422-61.594847 1.226944-16.444531 17.568121-15.523555 46.393633 2.053776 62.823837 90.322122 84.458577 151.246703 131.484613 214.417441 131.484613l56.209186 0-59.641355 57.824987c-17.033955 16.993023-17.060561 43.736107-0.057305 60.761875 8.511861 8.523117 19.678178 12.369725 30.844495 12.369725 11.140735 0 22.281469-4.453429 30.78719-12.939707L945.914574 757.311055c8.192589-8.173147 12.794397-19.315928 12.794397-30.881334 0-11.564383-4.601808-22.682605-12.794397-30.855752L811.706943 561.66105zM108.871593 337.471035l58.892295 0c45.932122 0 114.40154 58.455343 168.915108 107.942431 8.352225 7.576559 18.832927 12.140505 29.29214 12.140505 11.852956 0 23.673166-4.394077 32.270984-13.857613 16.182564-17.807574 14.859429-46.823422-2.958378-62.998823-85.247546-77.381391-156.561755-130.388652-227.519854-130.388652l-58.892295 0c-24.068162 0-43.581588 19.526729-43.581588 43.581588S84.804455 337.471035 108.871593 337.471035z"
                            p-id="1471"></path>
                    </svg>
                    选择播放设备
                </h1>
                
                <!-- 设备选择卡片 -->
                <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <!-- 通用播放器 -->
                    <div class="card bg-base-200 hover:bg-base-300 cursor-pointer transition-all duration-200 hover:shadow-lg"
                         :class="{ 'ring-2 ring-primary': selectedDevice === 'default' }"
                         @click="selectDevice('default')">
                        <div class="card-body items-center text-center">
                            <div class="avatar placeholder mb-4">
                                <div class="bg-primary text-primary-content rounded-full w-16">
                                    <svg class="w-8 h-8 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M512 96C282.624 96 96 282.624 96 512s186.624 416 416 416 416-186.624 416-416S741.376 96 512 96z m0 768C317.92 864 160 706.08 160 512S317.92 160 512 160s352 157.92 352 352-157.92 352-352 352z"/>
                                        <path d="M466.816 324.96a32 32 0 0 0-50.816 25.888v339.776a32 32 0 0 0 50.816 25.856l233.6-169.888a32 32 0 0 0 0-51.776l-233.6-169.856z"/>
                                    </svg>
                                </div>
                            </div>
                            <h2 class="card-title text-lg">通用播放器</h2>
                            <p class="text-sm opacity-70">支持本地播放和DLNA投送</p>
                            <div class="badge badge-primary mt-2">推荐</div>
                        </div>
                    </div>

                    <!-- DLNA设备 -->
                    <div class="card bg-base-200 hover:bg-base-300 cursor-pointer transition-all duration-200 hover:shadow-lg"
                         :class="{ 'ring-2 ring-secondary': selectedDevice === 'dlna' }"
                         @click="selectDevice('dlna')">
                        <div class="card-body items-center text-center">
                            <div class="avatar placeholder mb-4">
                                <div class="bg-secondary text-secondary-content rounded-full w-16">
                                    <svg class="w-8 h-8 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M128 256h768v512H128z m64 64v384h640V320H192z m160 128l192 96-192 96V448z"/>
                                    </svg>
                                </div>
                            </div>
                            <h2 class="card-title text-lg">DLNA设备</h2>
                            <p class="text-sm opacity-70">连接到网络音响或电视</p>
                            <div class="badge badge-secondary mt-2">专业</div>
                        </div>
                    </div>

                    <!-- 小米设备 -->
                    <div class="card bg-base-200 hover:bg-base-300 cursor-pointer transition-all duration-200 hover:shadow-lg"
                         :class="{ 'ring-2 ring-accent': selectedDevice === 'xiaomi' }"
                         @click="selectDevice('xiaomi')">
                        <div class="card-body items-center text-center">
                            <div class="avatar placeholder mb-4">
                                <div class="bg-accent text-accent-content rounded-full w-16">
                                    <svg class="w-8 h-8 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M512 176c158.784 0 288 123.136 288 274.56v90.24h38.4a57.6 57.6 0 0 1 57.6 57.6v192a57.6 57.6 0 0 1-57.6 57.6h-38.4a57.6 57.6 0 0 1-57.6-57.6V450.56c0-119.68-103.36-216.96-230.4-216.96S281.6 330.88 281.6 450.56v339.84a57.6 57.6 0 0 1-57.6 57.6h-38.4a57.6 57.6 0 0 1-57.6-57.6v-192a57.6 57.6 0 0 1 57.6-57.6h38.4V450.56c0-151.424 129.216-274.56 288-274.56z"/>
                                    </svg>
                                </div>
                            </div>
                            <h2 class="card-title text-lg">小米设备</h2>
                            <p class="text-sm opacity-70">连接小爱音箱或小米设备</p>
                            <div class="badge badge-accent mt-2">智能</div>
                        </div>
                    </div>
                </div>

                <!-- 设备状态信息 -->
                <div class="mt-6 p-4 bg-base-300 rounded-lg" v-if="selectedDevice">
                    <div class="flex items-center justify-between">
                        <div>
                            <h3 class="font-semibold">当前选择: {{ getDeviceName() }}</h3>
                            <p class="text-sm opacity-70">{{ getDeviceDescription() }}</p>
                        </div>
                        <button class="btn btn-primary" @click="navigateToQueue" :disabled="!selectedDevice">
                            进入播放页面
                            <svg class="w-4 h-4 ml-2 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M213.333333 331.349333c0-66.304 72.362667-107.306667 129.237334-73.173333l301.056 180.650667c55.253333 33.152 55.253333 113.194667 0 146.346666L342.613333 765.824c-56.874667 34.133333-129.237333-6.826667-129.237333-73.173333V331.349333zM599.722667 512L298.666667 331.349333v361.301334L599.722667 512zM768 256a42.666667 42.666667 0 0 1 42.666667 42.666667v426.666666a42.666667 42.666667 0 1 1-85.333334 0V298.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z"/>
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- 快速操作按钮 -->
                <div class="mt-6 flex flex-wrap gap-3">
                    <button class="btn btn-sm btn-outline" @click="refreshDevices">
                        <svg class="w-4 h-4 mr-1 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <path d="M512 896c-212.8 0-384-171.2-384-384s171.2-384 384-384c106.4 0 202.4 43.2 272 113.6L736 288h160V128l-54.4 54.4C776 118.4 649.6 64 512 64 229.6 64 0 293.6 0 576s229.6 512 512 512c282.4 0 512-229.6 512-512h-64c0 247.2-200.8 448-448 448z"/>
                        </svg>
                        刷新设备
                    </button>
                    <button class="btn btn-sm btn-outline" @click="showSettings = !showSettings">
                        <svg class="w-4 h-4 mr-1 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <path d="M512 320c-106.048 0-192 85.952-192 192s85.952 192 192 192 192-85.952 192-192-85.952-192-192-192z m0 320c-70.592 0-128-57.408-128-128s57.408-128 128-128 128 57.408 128 128-57.408 128-128 128z"/>
                        </svg>
                        设置
                    </button>
                </div>

                <!-- 设置面板 -->
                <div class="mt-4 p-4 bg-base-300 rounded-lg" v-if="showSettings">
                    <h4 class="font-semibold mb-3">播放设置</h4>
                    <div class="form-control">
                        <label class="label cursor-pointer">
                            <span class="label-text">自动切换到最后使用的设备</span>
                            <input type="checkbox" class="toggle toggle-primary" v-model="autoSwitchDevice" />
                        </label>
                    </div>
                    <div class="form-control">
                        <label class="label cursor-pointer">
                            <span class="label-text">记住设备选择</span>
                            <input type="checkbox" class="toggle toggle-primary" v-model="rememberDevice" />
                        </label>
                    </div>
                </div>
            </div>

            <!-- 暂无选择时的提示 -->
            <div class="flex-1 flex items-center justify-center" v-if="!selectedDevice">
                <div class="text-center">
                    <div class="text-6xl mb-4">🎵</div>
                    <h3 class="text-xl font-semibold mb-2">选择你的播放设备</h3>
                    <p class="text-gray-500">选择上方的设备类型开始播放音乐</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QueueIndex',
    data() {
        return {
            selectedDevice: null,
            showSettings: false,
            autoSwitchDevice: true,
            rememberDevice: true,
            deviceStatus: {
                default: 'available',
                dlna: 'checking',
                xiaomi: 'checking'
            }
        }
    },
    created() {
        this.loadSettings()
        this.checkDeviceAvailability()
        
        // 如果设置了自动切换设备，加载上次的选择
        if (this.autoSwitchDevice) {
            this.loadLastDevice()
        }
    },
    methods: {
        selectDevice(device) {
            this.selectedDevice = device
            
            // 保存选择
            if (this.rememberDevice) {
                this.saveLastDevice(device)
            }
            
            this.$myMsg.notify({
                title: `已选择${this.getDeviceName()}`,
                type: 'success',
                time: 2000,
            })
        },
        
        navigateToQueue() {
            if (!this.selectedDevice) return
            
            const routeMap = {
                'default': '/playing',
                'dlna': '/dlnaQueue', 
                'xiaomi': '/xiaoMiQueue'
            }
            
            const routePath = routeMap[this.selectedDevice]
            if (routePath) {
                this.$router.push(routePath)
            }
        },
        
        getDeviceName() {
            const names = {
                'default': '通用播放器',
                'dlna': 'DLNA设备',
                'xiaomi': '小米设备'
            }
            return names[this.selectedDevice] || ''
        },
        
        getDeviceDescription() {
            const descriptions = {
                'default': '支持本地播放和DLNA投送，功能最全面',
                'dlna': '专业级网络音频播放，适合高品质音响系统',
                'xiaomi': '智能家居生态，无缝连接小米设备'
            }
            return descriptions[this.selectedDevice] || ''
        },
        
        refreshDevices() {
            this.$myMsg.notify({
                title: '正在刷新设备列表...',
                type: 'info',
                time: 2000,
            })
            
            // 这里可以添加实际的设备刷新逻辑
            this.checkDeviceAvailability()
        },
        
        checkDeviceAvailability() {
            // 检查各设备的可用性
            // 这里可以添加实际的设备检测逻辑
            setTimeout(() => {
                this.deviceStatus = {
                    default: 'available',
                    dlna: 'available', 
                    xiaomi: 'available'
                }
            }, 1000)
        },
        
        loadSettings() {
            const settings = localStorage.getItem('queueSettings')
            if (settings) {
                const parsed = JSON.parse(settings)
                this.autoSwitchDevice = parsed.autoSwitchDevice ?? true
                this.rememberDevice = parsed.rememberDevice ?? true
            }
        },
        
        saveSettings() {
            const settings = {
                autoSwitchDevice: this.autoSwitchDevice,
                rememberDevice: this.rememberDevice
            }
            localStorage.setItem('queueSettings', JSON.stringify(settings))
        },
        
        loadLastDevice() {
            const lastDevice = localStorage.getItem('lastSelectedDevice')
            if (lastDevice && ['default', 'dlna', 'xiaomi'].includes(lastDevice)) {
                this.selectedDevice = lastDevice
            }
        },
        
        saveLastDevice(device) {
            localStorage.setItem('lastSelectedDevice', device)
        }
    },
    
    watch: {
        autoSwitchDevice() {
            this.saveSettings()
        },
        rememberDevice() {
            this.saveSettings()
        }
    }
}
</script>

<style scoped>
.card {
    transition: all 0.2s ease-in-out;
}

.card:hover {
    transform: translateY(-2px);
}

.h-screen-header {
    height: calc(100vh - 80px);
}

.ring-2 {
    box-shadow: 0 0 0 2px currentColor;
}
</style> 